import React, { createContext, useContext } from 'react'
import Barcode from 'react-barcode'
import { barcodeForMode, estimateModules, mmToPx } from 'helpers/barcode'

// Foydalanuvchi tanlaydigan shtrix-kod ko'rinishi (Sozlamalardan). Qiymatlar:
// 'auto' (haqiqiy EAN-13/EAN-8 -> o'z formati, aks holda CODE128) yoki aniq
// format nomi ('CODE128', 'CODE39', 'EAN13', 'ITF', ...). Standart 'auto'.
export const BarcodeModeContext = createContext('auto')

// Shtrix-kod egallashi mumkin bo'lgan eng katta en (mm). CODE128 kabi ko'p modulli
// (uzun) formatlar shu enga sig'adigan qilib avtomatik noziklashtiriladi -- yorliqda
// cho'zilib ketmaydi. EAN-13 va qisqa kodlar tabiiy o'lchamida qoladi. null -> cheksiz.
export const BarcodeMaxMmContext = createContext(null)

// Barcha narx yorliqlari uchun yagona shtrix-kod. Format tanlangan rejimga qarab
// aniqlanadi (tanlangan format kodga to'g'ri kelmasa CODE128 ga qaytadi -- bo'sh
// chiqmasin). Chaqiruvchi `format` ni oshkora bersa (masalan PriceTag_3 -- vertikal,
// resolveBarcode orqali o'z o'lchamiga moslangan) -- o'sha ishlatiladi va enga
// tegilmaydi. Qolgan proplar (height, fontSize, ...) react-barcode ga uzatiladi.
function TagBarcode({ value, format, lastChar, width, ...rest }) {
  const mode = useContext(BarcodeModeContext)
  const maxMm = useContext(BarcodeMaxMmContext)

  // Ko'rinmas bo'sh joylarni olib tashlaymiz -- aks holda "4870254132743 " kabi
  // qiymat EAN-13 tekshiruvidan o'tmay CODE128 ga tushib qoladi.
  const clean = String(value ?? '').trim()

  if (format) {
    return (
      <Barcode value={clean} format={format} lastChar={lastChar} width={width} {...rest} />
    )
  }

  const resolved = barcodeForMode(clean, mode)

  // Chiziq qalinligini yorliqqa moslash: agar tabiiy en (modul soni x width) maxMm
  // dan oshsa -- modulni nozikroq qilamiz (pastga yaxlitlanadi, qutidan chiqmasin).
  let finalWidth = width
  if (maxMm && width) {
    const modules = estimateModules(clean, resolved.format)
    const capPx = Math.floor((mmToPx(maxMm) / modules) * 100) / 100
    if (capPx > 0 && capPx < width) finalWidth = capPx
  }

  return (
    <Barcode
      value={clean}
      format={resolved.format}
      lastChar={resolved.lastChar}
      width={finalWidth}
      {...rest}
    />
  )
}

export default TagBarcode
